import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { 
    MaterialCommunityIcons,
    Feather 
   } from "@expo/vector-icons";
import colors from "../config/colors";

function LikeBrainButton({ statusLike  , onPress, style, styleBrainRed = ''}) {
 // console.log('stausLike ', styleBrainRed)
  return (
   
    <>
    {
      //.............................................
      //Sección que pinta el cerbro de los likes
      //.............................................
      statusLike === false ? 
      < MaterialCommunityIcons 
      style={styleBrainRed === '' ? style :  styleBrainRed}
       name={"brain"} 
       color={'red'} 
       size={27} 
       onPress={onPress} 
       />
       :
       <>
       <View
        style={style}>       
        <Feather
          style={styles.button}
          name={"sun"} 
          color={colors.fuente} 
          size={37} 
          onPress={onPress}
        >
          </Feather>
          {/* <Text style={txtStyle === '' ? styles.text : txtStyle}>{title}</Text> */}
        < View style={styles.brain }>
          < MaterialCommunityIcons //style={styles.brain }
                                                      name={"brain"} 
                                                      color={colors.chakra4azu} 
                                                      size={16} 
                                                      onPress={onPress}
          />
        </View>
       </View>
       </>
      }
      </>
  );
}

const styles = StyleSheet.create({
  brain:{
    
       backgroundColor: colors.white,
       borderRadius: 35,
        width: 21,//'10%',
        height: 21,//'80%',
        padding:2,
        marginTop:8.5,
        marginLeft:8.5,
        //alignSelf:'center',
        //alignContent:'center',
        //alignItems:'center'
  },
  containerLikePress:{
    marginLeft: "2%",
  },
  button: {
    position:'absolute',
    marginBottom:5,
    marginRight: -7,  
    //paddingRight:6
    // backgroundColor: colors.primary,
   
    // justifyContent: "center",
    // alignItems: "center",
    // padding: 10,
    // width: "100%",
    //marginLeft: "2%",
  },
  text: {
    color: colors.white,
    fontSize: 18,
    //textTransform: "uppercase",
    fontWeight: "bold",
  },
});

export default LikeBrainButton;
